import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { MatIconRegistry, MatDialog, MatSnackBar, MatRadioChange } from '@angular/material';

import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { NestService } from '../../services/nest.service';
import { CommonService } from '../../services/common.service';
import { RazorpayService } from '../../PaymentGateway/razorpay/razorpay.service';
import { AdduserpetComponent } from '../adduserpet/adduserpet.component';
import { AddmultipleproductComponent } from '../addmultipleproduct/addmultipleproduct.component';
import { SelecttotaldayComponent } from '../selecttotalday/selecttotalday.component';
import { EmergencycontactComponent } from '../emergencycontact/emergencycontact.component';
import { NestpaymodeComponent } from '../nestpaymode/nestpaymode.component';

import { MatStepper } from '@angular/material';
@Component({
  selector: 'app-nestbooking',
  templateUrl: './nestbooking.component.html',
  styleUrls: ['./nestbooking.component.css']
})
export class NestbookingComponent implements OnInit {
  step: MatStepper;
  roomservice = [];
  couponflag: number;
  discamount: number;
  newtotal: number;
  nestbooking: any;
  disclaimer: string;
  bookednestpets: any;
  coupon: number;
  couponid: any;
  originaltotal: any;
  address: any;
  hide: any;
  contact: any;
  uemail: any;
  petparent: any;
  uid: any;
  hidebooking = 0;

  public campaign = false;
  msg: any;
  action:any;
  user_id: any;
  petparent_name: any;

  checkindate : any;
  checkoutdate: any;
  today: any;
  loading: any;
  mincheckoutdate: any;
  totalroom = 1;
  city_id = 1;
  petdetail = [];
  nestservice: any;
  availservice = [];
  totaldays : any;
  totalpayable: any;
  discount = 0;
  discountper = 0;
  userpets : any;
  chckednumber = 0;
  foodchoice: any;
  foodchoicearray = ['yes','no'];
  cookedfoodservice = [];
  packagedfoodservice = [];
  pickanddrop: any;
  pickanddropservice = [];
 pickupadd:any;
 dropadd:any;
 pickup:any;
 drop:any;
 timing = ['7 A.M To 10 A.M','7 P.M To 10 P.M'];
 pickuptime: any;
 droptime:any;
 addedservice =[];
 alternetcontact: any;
 vetname: any;
 vetcontact: any;
 bno:any;

  userStatus: any;
  afterdate: string;
  startdate: any;
  enddate: any;
  roomoptions: any;
  todaysdate: any;
  pettype: any;
  totalpets: any;
  dummy = 2;
  total: any;
  couponcode: any;
  coupons= [];
  stepper: MatStepper;
  constructor( private _sanitizer: DomSanitizer, private commonService: CommonService,
    private nestService: NestService, public dialog:MatDialog, public snackBar: MatSnackBar,
  private meta: Meta, private razorpayService: RazorpayService ,) {
    this.couponflag = 0;
    var dat = this.getDate2();
    this.todaysdate = dat;
    this.disclaimer = null;
    this.discount = 0;
    this.totalpayable = 0;
    this.couponid = 0;
    this.coupon = 0;
    this.hide = 0;
    this.userStatus = this.commonService.checkUserStatus();
    if (this.userStatus === 1) {
      const udata = this.commonService.getUserDataLocally();
      this.user_id = udata.uid;
      this.petparent_name = udata.uname;
      this.uemail = udata.uemail;
      this.contact = udata.umobile;
      this.GetUserpets();
    }

    this.razorpayService.paymentstatus.subscribe(ps => {
      if (ps === 1) {
        this.nextAction();
      } else if(ps === 2) {
        this.msg = 'Payment is cancelled or your payment session is over';
        this.showAlert();
        this.razorpayService.managestatus.next(0);
        window.history.back();
      }
    });



  }

  ngOnInit() {
    this.getDate();
    this.getNestServices();
    this.getNestPetDetails(this.user_id);

   // this.getCoupons();
    var nest= 'nest';
    // this.coupons= [];
     this.couponcode = undefined;
      this.nestService.getAllCoupon(nest)
      .subscribe((x)=>{
        for(let i = 0; i < x.length; i++){
          if(x[i].code === 'NEST33OFF'){
            var date = moment(x[i].expiary);
            var now = moment(this.todaysdate);
            if(date >= now) {
                this.couponflag = 1;
                this.coupons.push(x[i]);
               console.log(this.couponflag);
            }
          } else {
            var date = moment(x[i].expiary);
            var now = moment(this.todaysdate);
            if(date >= now) {
              this.coupons.push(x[i]);
          }
          }
        }
        console.log('coupons', this.coupons);
    
      }); 

  }
  selectuser(){
   /* const dialogRef = this.dialog.open(SearchuserComponent,{
      width: '800px',
      height: '600px',
    } );
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.msg = 'user selected';
        this.showAlert();
        this.user_id = result.id;
        this.petparent_name = result.name;
        this.contact = result.mobile;
        this.GetUserpets();
        this.goToNext();
      }
    }); */
  }
  showAlert() {
    this.snackBar.open(this.msg, this.action , {
      duration: 4000,
    });
 }
 goToNext(){
   this.stepper.next();
 }
 goback1(stepper: MatStepper) {
   stepper.selectedIndex = 0;
 }

 goback2(stepper: MatStepper) {
  stepper.selectedIndex = 1;
}
 getDate(){
   this.loading = true;
   this.commonService.getTime()
   .subscribe(
     (x)=>{
      const ctime = x.date;
      this.today = moment(ctime.date).format('YYYY-MM-DD');
      this.loading = false;
      this.checkindate = this.today;
      this.mincheckoutdate = moment(this.checkindate).add(1,'days').format('YYYY-MM-DD');
     });
 }
 checkMin(e){
   this.mincheckoutdate = moment(this.checkindate).add(1,'days').format('YYYY-MM-DD');
   this.checkoutdate = undefined;
   }
   checkAvailablity(){
     this.petdetail = [];
     this.chckednumber = 0;
     this.cookedfoodservice = [];
     this.packagedfoodservice =[];
     var diff = moment(this.checkoutdate).diff(this.checkindate, "days")
        this.totaldays = diff;
     this.foodchoice = undefined;
     this.loading = true;
     this.nestService.getNestRoomAvailablity(this.checkindate,this.checkoutdate,this.totalroom,this.city_id)
     .subscribe(
       (x)=>{
         this.loading = false;
        if(x == 'Available'){
          this.hide = 1;
        }
        else{
          this.msg = "No Rooms Available in This Schedule";
          this.showAlert();
        }
       });
   }

   gobackToCheckAvailability(){
     this.hide = 0;
   }

   checkPetsInfo(e, id,name){
     if (e.target.checked) {
       this.createPetObject(id,name);
     }

    if ( !e.target.checked) {
      for ( let i = 0 ; i < this.petdetail.length; i++) {
        if ( this.petdetail[i].pet_id == id ) {
          this.petdetail.splice(i , 1);
        }
      }
      if(this.petdetail.length < this.totalroom){
        this.hidebooking = 0;
      }
      this.chckednumber = this.chckednumber - 1;
    }
    if(this.petdetail.length == 0){
      this.foodchoice = undefined;
    }

  }
  isPetChecked(id){
    for ( let i = 0 ; i < this.petdetail.length; i++) {
      if ( this.petdetail[i].pet_id === id ) {
        return true;
      }
    }
  }
  isDisable(id){
    for ( let i = 0 ; i < this.petdetail.length; i++) {
      if ( this.petdetail[i].pet_id === id ) {
        return true;
      }
    }
  }

  createUserPet(){
    const dialogRef = this.dialog.open(AdduserpetComponent,{
      width: '400px',
      height: '300px',
      data: {uid:this.user_id}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.GetUserpets();
      }
    });
  }
   createPetObject(id,name){
      var obj ={ 'pet_id':id,
                  'user_id':this.user_id,
                'pet_name' : name,
                'NeuteredOrSpayed': '',
                'gender':'',
                'nature':'',
                'age':'',
                'food_preference':'',
                'food_giving_option':'',
                'food_name':''};
      this.petdetail.push(obj);
      if(this.petdetail.length == this.totalroom){
        this.hidebooking = 1;
      }
      this.chckednumber = this.chckednumber + 1;
      this.prefillPetDetails(id);
    }
    getNestPetDetails(uid){
      this.nestService.getNestPetDetails(uid)
      .subscribe((x)=> {
        this.bookednestpets = x;
      });
    }

prefillPetDetails(petid) {
  for(let i = 0; i < this.petdetail.length; i++){
    for(let j = 0; j < this.bookednestpets.length; j++){
      if(this.petdetail[i].pet_id == this.bookednestpets[j].pet_id) {
        this.petdetail[i].gender = this.bookednestpets[j].gender;
        this.petdetail[i].age = this.bookednestpets[j].age;
        this.petdetail[i].NeuteredOrSpayed = this.bookednestpets[j].NeuteredOrSpayed;
        this.petdetail[i].nature = this.bookednestpets[j].nature;
        break;
      }
      }
    }
  }
    radioChangeForFoodOption(event: MatRadioChange,ar, stepper: MatStepper){
      console.log('radiochangeforfood');
      this.foodchoice = ar;
      if(this.foodchoice == 'yes'){
        for(let i = 0 ;i<this.petdetail.length ; i++ ){
          this.petdetail[i].food_giving_option = 'From Home';
          this.removeformPackagefood(this.petdetail[i].pet_id);
        }
        this.availservice = [];
       this.radioChangeForPickAndDrop(stepper);
      }
      if(this.foodchoice == 'no'){
        for(let i = 0 ;i<this.petdetail.length ; i++ ){
          this.petdetail[i].food_giving_option = 'From Petcart';
        }
        this.ChangeFoodPreference();
      }
    }
    ChangeFoodPreference(){
      for ( let i = 0 ; i < this.petdetail.length; i++) {

          this.petdetail[i].food_preference = "Packaged";
          this.petdetail[i].food_preferenceid = 4;


      }
    }
    removeFromCookedFood(pid){
      if(this.cookedfoodservice.length > 0){
        for ( let i = 0 ; i < this.cookedfoodservice.length; i++) {
          if ( this.cookedfoodservice[i].pet_id === pid ) {
            this.cookedfoodservice.splice(i,1);
          }
        }
      }
    }
    addCookedfood(event: MatRadioChange,serv,pid){
      for ( let i = 0 ; i < this.cookedfoodservice.length; i++) {
        if ( this.cookedfoodservice[i].pet_id === pid ) {
          this.cookedfoodservice.splice(i,1);
        }
      }
      var pay = serv.fees*this.totaldays;
      var obj = {'pet_id':pid,'name':serv.name,'service_id':serv.id,'fees':serv.fees,
     'payable': pay};
      this.cookedfoodservice.push(obj);
    }

    buyFoodFrompetcart(pid){
      var pidarr =[];
      if(this.packagedfoodservice.length>0){
        for(let i=0;i<this.packagedfoodservice.length;i++){
          if(this.packagedfoodservice[i].pet_id == pid){
            pidarr.push(this.packagedfoodservice[i].name);
          }
        }
      }

      let dialogRef = this.dialog.open(AddmultipleproductComponent,
        {height: '700px',
          width: '700px',
          data:{'name':pidarr}});
        dialogRef.afterClosed().subscribe(
          (res)=>{
            if(res) {
             for(let i =0 ;i<res.length ; i++){
               var fee: any;
               if(res[i].splprice==0||res[i].splprice==undefined){
                 fee = res[i].price;
               }
               else{
                fee = res[i].splprice;
               }
              var obj = {'pet_id':pid,'name':res[i].name,'service_id':4,'fees':fee,
            'qty':1,'payable': fee};
              this.packagedfoodservice.push(obj);
             }

            }
          });
     }
     removeformPackagefood(pid){
      if(this.packagedfoodservice.length > 0){
        let i = this.packagedfoodservice.length - 1;
        while (i>=0) {
          if ( this.packagedfoodservice[i].pet_id === pid ) {
            this.packagedfoodservice.splice(i,1);
          }
          i = i-1;
        }
      }
     }
     ispackageFoodalreadyAdded(pid){
       var counter = 0;
      for ( let i = 0 ; i < this.packagedfoodservice.length; i++) {
        if ( this.packagedfoodservice[i].pet_id === pid ) {
          counter = counter +1;
        }
      }
      if(counter>0){
        return true;
      }
      else{
        return false;
      }
     }
     isCookfoodtypeselected(pid){
      var counter = 0;
      for ( let i = 0 ; i < this.cookedfoodservice.length; i++) {
        if ( this.cookedfoodservice[i].pet_id === pid ) {
          counter = counter +1;
        }
      }
      if(counter>0){
        return true;
      }
      else{
        return false;
      }
     }
     removeparticularpackageFood(index){
      this.packagedfoodservice.splice(index,1);
     }
     addQty(index){
      this.packagedfoodservice[index].qty = this.packagedfoodservice[index].qty + 1;
      this.packagedfoodservice[index].payable =  this.packagedfoodservice[index].fees*this.packagedfoodservice[index].qty;
     }
     subQty(index){
      this.packagedfoodservice[index].qty = this.packagedfoodservice[index].qty - 1;
      this.packagedfoodservice[index].payable =  this.packagedfoodservice[index].fees*this.packagedfoodservice[index].qty;
     }
     radioChangeForPickAndDrop(stepper: MatStepper){
      this.coupon = 0;
      this.couponid = 0;
        this.pickanddrop = 'no';
        if(this.pickanddrop === 'no'){
          console.log('radiochangeforpickupanddrop');
          this.compleatefoodpart(stepper);
         // this.goToSummery();

        }
        if(this.pickanddrop === 'yes') {
        for(let i = 0; i < this.nestservice.length; i++) {

          if(this.nestservice[i].type_id == 10) {
              var obj1 = {
                service_id: this.nestservice[i].id,
                name: this.nestservice[i].name,
                days: 1,
                fees: this.nestservice[i].fees,
                payable: this.nestservice[i].fees,
              };
              this.pickanddropservice.push(obj1);
              if(this.nestservice[i].id == 11){
                this.pickup = 'yes';
               }
               if(this.nestservice[i].id == 12){
                this.drop = 'yes';
               }
          }
        }

        }
     }

     checked2(e) {
      if(e.target.checked) {
        this.disclaimer = 'Yes';
      }
      if(!e.target.checked) {
        this.disclaimer = null;
      }
    }

     compleatefoodpart(stepper: MatStepper){
       if(this.foodchoice == 'yes'){
         console.log('compleate', this.foodchoice, this.pickanddrop);
        if(this.pickanddrop == 'no'){
          console.log('here if yes');
          stepper.selectedIndex = 2;
          this.pushIntoAvailService();
         }
       } else {
         var check = 0;
         var check1= 0;
         var counter = this.petdetail.length;
         for(let i=0; i<this.petdetail.length; i++){
           if(this.petdetail[i].food_preferenceid&&this.petdetail[i].food_preferenceid==3){
             var ic = this.isCookfoodtypeselected(this.petdetail[i].pet_id);
             if(ic == false){
               check = 1
             }
           }
           else if(this.petdetail[i].food_preferenceid&&this.petdetail[i].food_preferenceid==4){
            var ic1 = this.ispackageFoodalreadyAdded(this.petdetail[i].pet_id);
            if(ic1 == false){
              check1 = 1
            }
           }
           else{
            check1 = 1;
            check = 1;
          }
          }
          if(check==0 && check1==0){
            if(this.pickanddrop === 'no'){
              console.log('here if no');
              stepper.selectedIndex = 2;
              this.pushIntoAvailService();
             //  this.steppers.goto(3);
             // this.stepper.next();
             } else{
             // this.stepper.next();
             stepper.selectedIndex = 2;

             }
          } else{
            this.msg = "Please fill up All the detail";
            this.showAlert();
          }
        }
     }

  addingpickanddrop(e,serv){
    if (e.target.checked) {
      var obj1 ={
        service_id:serv.id,
        name: serv.name,
        days: 1,
        fees: serv.fees,
        payable: serv.fees,
      };
      this.pickanddropservice.push(obj1);
      if(serv.id == 11){
        this.pickup = 'yes';
       }
       if(serv.id == 12){
        this.drop = 'yes';
       }
    }

   if ( !e.target.checked) {
     for ( let i = 0 ; i < this.pickanddropservice.length; i++) {
       if ( this.pickanddropservice[i].service_id == serv.id ) {
         this.pickanddropservice.splice(i , 1);
       }
     }
     if(serv.id == 11){
    //  this.pickupadd = undefined;
      this.pickuptime = undefined
      this.pickup = 'no';
     }
     if(serv.id == 12){
    //  this.dropadd = undefined;
      this.droptime = undefined;
      this.drop = 'no';
     }
   }

  }
  radioChangeForPickUpTime(event: MatRadioChange,ti){
    this.pickuptime = ti;
  }
  radioChangeForDropTime(event: MatRadioChange,ti){
    this.droptime = ti;
  }
  goToSummery(){

    if(this.pickanddrop == 'no'){
      this.address = undefined;
     // this.pushIntoAvailService();
    //   this.stepper.next();
    }
    else{
      var flag = 0;
      var flag2 = 0;
      if(this.pickup=='yes'){
        if(this.address == undefined || this.pickuptime == undefined){
          flag = 1
        }
      }
      if(this.drop=='yes'){
        if(this.address == undefined || this.droptime == undefined){
          flag = 1
        }
      }
      if(flag==0&&flag2==0){
        this.pushIntoAvailService();
       this.stepper.next();
      }
      else{
        this.msg ='Please Fill Up Details properly';
        this.showAlert();
      }
    }
  }
  pushIntoAvailService(){
    this.availservice = [];
    for(let i=0;i<this.nestservice.length; i++){
      if(this.nestservice[i].id == 1){
        var payable = this.nestservice[i].fees * this.totaldays * this.totalroom;
        var obj1 ={
          service_id:this.nestservice[i].id,
          pet_id: 0,
          name: this.nestservice[i].name,
          days: this.totaldays,
          fees: this.nestservice[i].fees,
          payable: payable,
        };
        this.availservice.push(obj1);
        this.roomservice.push(obj1);
      }
    }
  /* if(this.cookedfoodservice.length>0){
      for(let i =0; i<this.cookedfoodservice.length ; i++){
        var obj ={
          service_id:this.cookedfoodservice[i].service_id,
          name: this.cookedfoodservice[i].name,
          days: this.totaldays,
          fees: this.cookedfoodservice[i].fees,
          payable: this.cookedfoodservice[i].payable
        };
        this.availservice.push(obj);
      }
    } */
    if(this.packagedfoodservice.length>0){
      for(let i =0; i<this.packagedfoodservice.length ; i++){
        var obj ={
          service_id:this.packagedfoodservice[i].service_id,
          pet_id: this.packagedfoodservice[i].pet_id,
          name: this.packagedfoodservice[i].name,
          days: this.packagedfoodservice[i].qty,
          fees: this.packagedfoodservice[i].fees,
          payable: this.packagedfoodservice[i].payable
        };
        this.availservice.push(obj);
      }
    }
    
      if(this.pickanddropservice.length>0){
        for(let i = 0 ;i<this.pickanddropservice.length ; i++){
          this.availservice.push(this.pickanddropservice[i]);
        } 
      }
      console.log('availservice', this.availservice);
      this.calculateFees();
  }
  calculateFees(){
    this.totalpayable = 0;
    this.discount = 0;
    for(let i = 0; i< this.availservice.length;i++) {
      this.totalpayable  =  this.totalpayable + this.availservice[i].payable;
    }
    console.log('total',this.availservice, this.totalpayable);

    if(this.addedservice.length>0){
     for(let i = 0; i< this.addedservice.length;i++){
       this.totalpayable  =  this.totalpayable + this.addedservice[i].payable;
     }
    }
  //  this.discount = (this.totalpayable * this.discountper)/100
  //  this.totalpayable = this.totalpayable - this.discount;
  this.couponcode = undefined;
    if(this.couponflag == 1) {
        var daydisc = this.totaldays / 3;
        daydisc= Math.floor(daydisc);
        this.totalpayable = this.totalpayable -(daydisc * this.roomservice[0].fees * this.totalroom);
        this.discount = this.roomservice[0].fees * (daydisc * this.totalroom);
        if(this.discount > 0){
          this.coupon = 1;
          this.couponid = 2;
          this.couponcode= 'NEST33OFF';
        } else {
          this.coupon = 0;
          this.couponid = 0;
          this.couponcode= undefined;
        }
    }

   /* if(this.discount == 0) {
      this.coupon = 0;
      this.couponid = 2;
      this.couponcode = undefined;
    } */

  /* var nest= 'nest';
  // this.coupons= [];
   this.couponcode = undefined;
    this.nestService.getAllCoupon(nest)
    .subscribe((x)=>{
      for(let i = 0; i < x.length; i++){
        if(x[i].code === 'NEST33OFF'){
          var date = moment(x[i].expiary);
          var now = moment(this.todaysdate);
     
          if(date >= now){
           // this.coupons= [];
           this.coupons.push(x[i]);
           this.couponcode= 'NEST33OFF';
           this.coupon = 1;
           this.couponid = x[i].id;
           for(let j = 0; j < this.totalroom; j++) {
            var daydisc = this.totaldays / 3;
            daydisc= Math.floor(daydisc);
            console.log(daydisc);
            for(let k = 0; k < this.nestservice.length; k++){
              var fees = daydisc * this.nestservice[k].fees;
              this.totalpayable  =  this.totalpayable - fees;
              this.discount = this.discount + fees;
              console.log(fees, this.totalpayable);
            }
        
           }
           break;
          }
        }
      }
  
    });  */
    
    this.goToSummery();
    }
   isAvail(id){
     var flag = 0;
     for(let i = 0; i<this.addedservice.length;i++){
       if(this.addedservice[i].service_id == id){
         flag = flag + 1;
       }
     }
    if(flag == 1){
      return true;
    } else{
      return false;
    }
   }
   removeService(index, payable){
     this.addedservice.splice(index,1);
    // this.calculateFees();
    this.calculateFees2(payable);
   }
   addService(id,name,fees){
     const dialogRef = this.dialog.open(SelecttotaldayComponent,{
       width: '400px',
       height: '300px',
       data: {day:this.totaldays, max:this.totaldays}
     });
     dialogRef.afterClosed().subscribe(result => {
       if (result) {
        var payable = fees * result ;
        var obj ={
         service_id: id,
         name: name,
         days: result,
         fees: fees,
         payable: payable
       };
       this.addedservice.push(obj);
     //  this.calculateFees();
     this.calculateFees1(payable);
       }
     });
   }

   calculateFees1(payable) {
    this.totalpayable = this.totalpayable + payable;
   }

   calculateFees2(payable) {
    this.totalpayable = this.totalpayable - payable;
   }



   removeCouponCode() {
    this.coupon = 0;
    this.couponid = 0;
    console.log(this.totalpayable, this.discount);
    this.totalpayable = this.totalpayable + this.discount;

    this.discount = 0;
    console.log(this.totalpayable, this.discount);

  }
  bookRoom(stepper: MatStepper){
    var pos = this.Bookpossible();
    if(pos == 0){
      this.msg = "Please Fill Up all Details";
      this.showAlert();
    }
    else{
    // this.stepper.next();
    stepper.selectedIndex = 1;
    }

    this.cookedfoodservice = [];
    this.packagedfoodservice = [];
    for(let i = 0 ;i<this.petdetail.length ;i ++) {
      this.petdetail[i].food_preference = '';
      this.petdetail[i].food_name = '';
      this.petdetail[i].food_preferenceid = '';
    }
  }
  Bookpossible(){
    console.log(this.petdetail.length);
    var chances = 1;
    for(let i = 0 ;i<this.petdetail.length; i++){
      if(this.petdetail[i].NeuteredOrSpayed == "" || this.petdetail[i].gender == ""
     || this.petdetail[i].nature == ""  || this.petdetail[i].age == ""||
     this.petdetail[i].vet_name == "" || this.petdetail[i].vet_contact == "" || this.petdetail.length != this.totalroom){
        chances = 0;
        break;
      }
    }
    return chances;
  }

  openEmergencyPage(stepper: MatStepper) {
    this.step = stepper;
    if(this.disclaimer === null){
      this.msg = 'Check the disclaimer to proceed';
      this.showAlert();
    } else {
      this.alternetcontact= "Not Specified";
     // this.vetname = 'Unspecified';
     // this.vetcontact= 0;
      const dialogRef = this.dialog.open(EmergencycontactComponent ,{
        width: '400px',
        height: '400px',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.length > 0) {
         if(result[0].alternatecontact !== null && result[0].alternatecontact !== undefined){
          this.alternetcontact = result[0].alternatecontact;
         }
         if(result[0].vetname !== undefined && result[0].vetname !== ''){
          this.vetname = result[0].vetname;
         }
         if(result[0].vetcontact !== null && result[0].vetcontact !== undefined){
          this.vetcontact = result[0].vetcontact;
         }
         this.confirmBookingWithUs();
        } else {
          this.confirmBookingWithUs();
        }
      });
    }

   }

confirmBookingWithUs(){

    this.disclaimer = 'I Agree'
    var payment_status: any;;
    var booking_status:any;
    var pickup_service:any;
    var drop_service: any;
       payment_status = 'Pending';
       booking_status = 'Not confirmed';
    if(this.address && this.pickuptime){
      pickup_service = 'Yes'
    }
    else{
      pickup_service = 'No'
    }
    if(this.address && this.droptime){
      pickup_service = 'Yes'
    }
    else{
      drop_service = 'No'
    }
    this.loading = true;
    this.discount = Math.round(this.discount);
    this.totalpayable = Math.round(this.totalpayable);
    var rstring = this.randomString();
    const str1 =  'NEST' ;
    var booking_no = str1 + this.user_id + rstring;
    var amount  = this.totalpayable + this.discount;
    var booking_type = 'WebApp';
    var booking_for = 'Dog';
   

  //  this.alternetcontact = 0;
 //   this.vetname = "Unspecified";
//    this.vetcontact = 0;
    this.nestService.BookingRooms(this.city_id,booking_no,this.user_id,this.petparent_name,
    this.contact,booking_for,this.totalroom,this.checkindate,this.checkoutdate,amount,this.discount,
     this.totalpayable,payment_status,booking_status,booking_type,this.couponid,this.alternetcontact,this.vetname,
    this.vetcontact,pickup_service,drop_service, this.disclaimer)
     .subscribe(
       (x)=>{
         this.nestbooking = x;
         console.log(this.nestbooking.id);
         this.SimplifyPetDetail(booking_no);
         this.addPickupDrop(booking_no);
         this.confirmBookingServices(booking_no);


       }
     )


}
SimplifyPetDetail(bno){
  for(let i = 0 ; i<this.petdetail.length ;i++){
    var fname = this.genPetFoodname(this.petdetail[i].food_preferenceid,this.petdetail[i].pet_id);
    this.petdetail[i].food_name = fname;
    this.petdetail[i].booking_no = bno;
    delete this.petdetail[i].food_preferenceid;
  }
  this.nestService.createNestBookingPetInfo(this.petdetail)
  .subscribe(
    (x)=>{
      console.log(x);
    });
}
addPickupDrop(bno){
  if(this.pickup == 'yes' || this.drop == 'yes'){
    var ps = 'Pending';
    var ds = 'pending';
    this.nestService.addPickAndDrop(bno,this.pickuptime,this.address,this.droptime,
      this.address,this.totalroom,ps,ds)
      .subscribe(
        (x)=>{

        });
  }
  else{
    console.log('no pick and drop');
  }
}
genPetFoodname(fid,pid){
  if(fid ==4){
    var pn = '_';
    var t = '';
    var a:any;
   for(let i = 0; i<this.packagedfoodservice.length;i++){
      if(this.packagedfoodservice[i].pet_id==pid ){
        a = pn + this.packagedfoodservice[i].name;
        t = t + a;
      }
    }
    return t;
  }
  if(fid == 3){
    var px = '';
    for(let i=0;i<this.cookedfoodservice.length;i++){
      if( this.cookedfoodservice[i].pet_id ==pid ){
        px = px + this.cookedfoodservice[i].name;
      }
    }
    return px;
  }
}

randomString() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
  const string_length = 5;
  let randomstring = '';
  for (let i = 0; i < string_length; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
 }
 confirmBookingServices(bno){
   if(this.addedservice.length>0){
    for(let i = 0; i<this.addedservice.length;i++){
      this.availservice.push(this.addedservice[i]);
    }
   }

   for(let i = 0; i<this.availservice.length;i++){
     this.availservice[i].booking_no = bno;
   }
  this.nestService.confirmBookingServices(bno,this.availservice)
   .subscribe(
     (x)=>{
       this.loading = false;
       this.bno = bno;
      // this.goToNext();
      this.openPaymentPage();
     }
   )
 }

 openPaymentPage(){
  const dialogRef = this.dialog.open(NestpaymodeComponent ,{
    width: '500px',
    height: '500px',
    disableClose: true,
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result === 'Offline') {
      console.log('in if', result);
      this.msg = "Booking Confirmed";
      this.showAlert();
     // this.goToNext();
     this.step.selectedIndex = 3;
    } else {
      console.log('in else', result);
      this.pay();
    }
  });
 }

 pay(){
  var type = 'nest';
  this.razorpayService.createtransaction(this.petparent_name, this.uemail, this.contact, this.totalpayable, this.uid, type)
 }
 goToPetInfoStep() {
   this.cookedfoodservice = [];
   this.packagedfoodservice = [];
   for(let i = 0 ;i<this.petdetail.length ;i ++) {
     this.petdetail[i].food_preference = '';
     this.petdetail[i].food_name = '';
     this.petdetail[i].food_preferenceid = '';
   }

   this.stepper.next();
 }
 GetUserpets(){
   this.nestService.getUserPets(this.user_id)
   .subscribe(
     (x)=>{
      this.userpets = x;
     }
   );
 }
 getNestServices() {
  this.nestService.getnestServices()
  .subscribe(
    (x)=>{
      this.nestservice = x;
    });
 }

 private nextAction() {
  const paymentid = this.razorpayService.getPaymentId();
  this.loading = true;
  if( paymentid !== undefined){
 var order_id = this.nestbooking.id;
  const order_type = 'nest';
   console.log('order id',order_id, this.nestbooking.id);
  this.razorpayService.initiateTransaction(this.user_id, paymentid, this.totalpayable, order_id,
  order_type)
  .subscribe(
    (x) => {
      this.loading = false;
      this.updatePaymentStatus();
    });
  } else {
    this.loading = false;
    this.razorpayService.managestatus.next(0);
    this.msg = 'Booking Successful';
    this.showAlert();
    this.step.selectedIndex = 3;
   // this.stepper.next();
  }
}
updatePaymentStatus() {
  this.loading = true;
  const stat = 'Complete';
  const status = 'Confirmed';
  this.nestService.updateNestPayment(this.nestbooking.id, stat, status)
    .subscribe(
      (x) => {
        this.loading = false;
        this.razorpayService.managestatus.next(0);
        this.msg = 'Booking Successful';
        this.showAlert();
      // this.stepper.next();
      this.step.selectedIndex = 3;
      });
}




 getDate2(){
  var today = new Date();
  var d:string;
  var m: string;
  var dd = today.getDate();
  var mm = today.getMonth()+1; //January is 0!
  var yyyy = today.getFullYear();
  var da:any;


  if(dd<10) {
    d = '0'+dd;
  } else
    d= dd.toString();

  if(mm<10) {
    m = '0'+mm
  } else
    m = mm.toString();
  da = yyyy + '-' + m + '-' + d
  return da.toString();
}

getCoupons(){
  var nest= 'nest';
  this.nestService.getAllCoupon(nest)
  .subscribe((x)=>{
    for(let i = 0; i < x.length; i++){
      var date = moment(x[i].expiary);
      var now = moment(this.todaysdate);
  //    const dateMoment = moment(x[i].expiary, 'YYYY/MM/DD');
  //    const da = dateMoment.date();
      if(date >= now){
       this.coupons.push(x[i]);
      }
    }

  });
} 


addCoupon(){
  console.log('here', this.couponcode);
  var a = 0;
  for(let i = 0; i < this.coupons.length; i++){
    if(this.couponcode == this.coupons[i].code && this.totalpayable >= this.coupons[i].minval){
      a = 0;
      var discount = this.coupons[i].discount;
      var id = this.coupons[i].id;
        this.newtotal = this.totalpayable - (this.totalpayable * discount / 100);
        this.discamount = this.totalpayable - this.newtotal;
        this.coupon = 1;
        this.couponid = id;
        this.discount = this.discamount;
        this.originaltotal = this.totalpayable;
        this.totalpayable = this.newtotal;
        this.totalpayable = Math.round(this.totalpayable);
        this.discount = Math.round(this.discount);

      break;
  } else {
    a = 1;
  }

  }
  if(a == 1){
    this.msg = 'The Amount is less than the minimum value Or you may have entered an invalid code';
    this.showAlert();
  }


}


}
